import { render, staticRenderFns } from "./HealthAdd.vue?vue&type=template&id=537f0114&scoped=true&"
import script from "./HealthAdd.vue?vue&type=script&lang=js&"
export * from "./HealthAdd.vue?vue&type=script&lang=js&"
import style0 from "./HealthAdd.vue?vue&type=style&index=0&id=537f0114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f0114",
  null
  
)

component.options.__file = "HealthAdd.vue"
export default component.exports